import { NgModule } from '@angular/core';
import { StaticContentRoutingModule } from './static-content-routing.module';


@NgModule({
  imports: [
    StaticContentRoutingModule
  ],
  providers: [
   
  ]
})
export class StaticContent { }
